import { useTranslation } from 'react-i18next'

import { ClubModelMetadata } from '../../../../../../../types/court/court'
import { displayHourMinute } from '../../../../../../../utils/dateUtils'
import { formatMinutes } from '../../../../../../../utils/booking/booking'

type ClubCardDetailsProps = {
  club: ClubModelMetadata
}

export const ClubCardDetails = ({ club }: ClubCardDetailsProps) => {
  const { t } = useTranslation('clubs')

  const schedule = [
    { label: t('clubs.card.open-time'), value: displayHourMinute(club.openTime) },
    { label: t('clubs.card.close-time'), value: displayHourMinute(club.closeTime) },
    {
      label: t('clubs.card.session-durations'),
      value: club.sessionDurations?.length ? [...club.sessionDurations].sort((a, b) => a - b).map(formatMinutes).join(' · ') : '-',
    },
    {
      label: t('clubs.card.start-increment'),
      value: club.startIncrementMinutes ? formatMinutes(club.startIncrementMinutes) : '-',
    },
  ]

  const policies = [
    {
      label: t('clubs.card.free-cancellation'),
      value: t('clubs.card.hours', { count: club.freeCancellation }),
    },
    {
      label: t('clubs.card.max-reschedules'),
      value: club.maxReschedules ?? '-',
    },
    {
      label: t('clubs.card.pass-extension'),
      value: club.passExtensionDays !== undefined
        ? t('clubs.card.days', { count: club.passExtensionDays })
        : '-',
    },
  ]

  return (
    <div className="club-card-details">
      {[schedule, policies].map((column, index) => (
        <div key={index} className="club-card-details-column">
          {column.map(detail => (
            <div key={detail.label} className="ph-row ph-between club-card-detail">
              <span className="muted">{detail.label}</span>
              <span className="mono">{detail.value}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
